function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#429AF6",
  fillRule: "evenodd",
  d: "M6 4h4v2H6v4H4V6H0V4h4V0h2v4z"
});

var SvgPlusIcon = function SvgPlusIcon(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _ref);
};

export default SvgPlusIcon;